import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { buildMyPropertiesMarketRedirectPath } from "../utils/clientMyPropertiesTabs";

/**
 * CL-372B: Legacy /client-portal/account/market-snapshot → My Properties Market tab.
 */
export default function ClientMarketSnapshotLegacyRedirect() {
  const { search } = useLocation();
  const target = buildMyPropertiesMarketRedirectPath(search);

  return (
    <div className="mx-auto max-w-lg px-4 py-10 space-y-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Redirecting…</p>
      <h1 className="text-lg font-semibold text-slate-900">My market moved to My Properties</h1>
      <p className="text-sm text-slate-600">
        Saved property research and market tools now live under{" "}
        <span className="font-medium text-slate-800">Real Estate → My Properties</span> on the Market tab.
      </p>
      <Link to={target} className="inline-block text-sm font-medium text-slate-900 underline">
        Continue to My Properties
      </Link>
      <Navigate to={target} replace />
    </div>
  );
}
